

















































import Component, { mixins } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import UrlMixin from '@/mixins/url';

import HiddenField from '@/components/Atoms/Input/HiddenField.vue';
import SubmitButton from '@/components/Atoms/Button/SubmitButton.vue';
import { MobileConfig } from '@/data/mobileConfig';
import { VasConfig } from '@/data/vasConfig';

@Component({
  components: { SubmitButton, HiddenField },
})
export default class ApplyForm extends mixins(UrlMixin) {
  private formName = 'no_auth_estimate_apply_form';
  private vasConfig = new VasConfig();
  @Prop() disabled!: boolean;

  @Prop() code!: string;
  @Prop() mobileConfig!: MobileConfig;

  get plans() {
    return this.$store.getters['mobile/find']({ stateKey: 'plans' });
  }

  get options() {
    return this.$store.getters['mobile/find']({ stateKey: 'options' });
  }

  get terminals() {
    return this.$store.getters['mobile/find']({ stateKey: 'terminals' });
  }

  get vas() {
    return this.$store.getters['vas/find']({});
  }

  get initialTotalAmount(): number {
    return (
      Number(this.$store.getters['vas/initialTotalAmount']) +
      Number(
        this.$store.getters['mobile/initialTotalAmount'](this.mobileConfig)
      )
    );
  }

  get totalAmountOfMonth(): number {
    return (
      Number(this.$store.getters['vas/totalAmountOfMonth']) +
      Number(
        this.$store.getters['mobile/totalAmountOfMonth'](this.mobileConfig)
      )
    );
  }

  get manager(): number {
    return Number(this.$store.getters['mobile/managerCount']);
  }

  get user(): number {
    return Number(this.$store.getters['mobile/userCount']);
  }

  inputFieldName(
    item: any,
    type: 'plan' | 'option' | 'terminal' | 'vas'
  ): string {
    switch (type) {
      case 'plan':
        return `${this.formName}[${item.simType}][plan][${item.carrier}][${item.id}]`;
      case 'option':
        return `${this.formName}[${item.simType}][option][${item.carrier}][${item.id}]`;
      case 'terminal':
        return `${this.formName}[goods][${item.id}]`;
      case 'vas': {
        const vas = this.vasConfig.getVas(item.id);
        return `${this.formName}[vas][${vas.categoryId}][${item.id}]`;
      }
    }
  }
}
